import { z } from 'zod';

import Logger from './CapcitorLog';

export function validateSchema<Type>(name: string, event: Type, schema: z.ZodType<Type>) {
  const result = schema.safeParse(event);
  if (!result.success) {
    Logger.error(`Invalid ${name} event`, result.error.format());
    return;
  }

  return result.data;
}
